import WorkerTabs from "@/views/workers/components/WorkerDetails/WorkerTabs";
import WorkerProfile from "@/views/workers/components/WorkerDetails/components/WorkerProfile/WorkerProfile";
import Workers from "@/views/workers/WorkerList.vue";
import WorkerActivity from "@/views/workers/components/WorkerDetails/components/WorkerActivity/WorkerActivity";
import { redirectWithPermissionCheck } from "@/router/index";
import TalentPools from "@/views/workers/TalentPools/TalentPoolList.vue";
import TalentPool from "@/views/workers/TalentPools/components/TalentPool.vue";

export const workersRouter = [
  {
    path: "/candidates",
    name: "workers",
    component: Workers,
    beforeEnter: (to, from, next) => {
      return redirectWithPermissionCheck(next, "workers");
    }
  },
  {
    path: "/talentpools",
    name: "talentPools",
    component: TalentPools
  },
  {
    path: "/talentpools/:id",
    name: "talentPoolPeople",
    component: TalentPool
  },
  {
    path: "/candidates/:id",
    name: "workerTabs",
    redirect: "/candidates/:id/profile",
    component: WorkerTabs,
    beforeEnter: (to, from, next) => {
      return redirectWithPermissionCheck(next, "workers.view");
    },
    children: [
      {
        path: "profile",
        name: "workerProfile",
        component: WorkerProfile,
        beforeEnter: (to, from, next) => {
          return redirectWithPermissionCheck(next, "workers.view");
        }
      },
      {
        path: "activity",
        name: "workerActivity",
        component: WorkerActivity,
        beforeEnter: (to, from, next) => {
          return redirectWithPermissionCheck(next, "workers.view");
        }
      }
    ]
  }
];
